import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * SettingsPage — placeholder settings page.
 */
const SettingsPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'radial-gradient(ellipse at 50% 40%, rgba(2,12,8,0.6), rgba(0,0,0,0.95))',
        }}>
            <div style={{
                width: 'min(560px, 90vw)', padding: '48px 32px',
                borderRadius: 16, textAlign: 'center',
                background: 'rgba(5,14,10,0.55)',
                border: '1px solid rgba(16,185,129,0.18)',
                backdropFilter: 'blur(12px)',
            }}>
                <h1 style={{
                    fontFamily: "'Orbitron', sans-serif", fontSize: 28,
                    fontWeight: 800, letterSpacing: '0.15em',
                    color: 'rgba(230,255,250,0.92)', marginBottom: 8,
                }}>SETTINGS</h1>
                <p style={{ color: 'rgba(180,200,195,0.7)', lineHeight: 1.7, marginBottom: 32 }}>
                    App preferences and configuration coming soon.
                </p>
                <button
                    onClick={() => navigate('/home')}
                    style={{
                        fontFamily: "'Orbitron', sans-serif", fontSize: 13,
                        fontWeight: 700, letterSpacing: '0.12em',
                        color: 'rgba(230,255,250,0.85)',
                        background: 'rgba(16,185,129,0.12)',
                        border: '1px solid rgba(16,185,129,0.3)',
                        borderRadius: 10, padding: '10px 28px', cursor: 'pointer',
                    }}
                >
                    ← BACK TO HOME
                </button>
            </div>
        </div>
    );
};

export default SettingsPage;
